import { useContext } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, NavLink } from "react-router-dom";
import UserContext from "../context/UserContext";

export default function AppNavbar() {
  const { user } = useContext(UserContext);

  return (
    <Navbar expand="lg" className="navbar-custom">
      <Container>
        {/* Brand */}
        <Navbar.Brand as={NavLink} to="/" className="navbar-brand-custom">
          Dessert Haven
        </Navbar.Brand>

        {/* Mobile menu button */}
        <Navbar.Toggle aria-controls="navbar-responsive" />

        <Navbar.Collapse id="navbar-responsive">
          {/* Main Navigation */}
          <Nav className="mx-auto navbar-main-links">
            <Nav.Link as={NavLink} to="/about">
              About Us
            </Nav.Link>

            <Nav.Link as={NavLink} to="/products">
              Desserts
            </Nav.Link>
          </Nav>

          {/* User Navigation */}
          <Nav className="navbar-user-links">
            {user.id !== null && !user.isAdmin && (
              <>
                <Nav.Link as={NavLink} to="/cart">
                  Cart
                </Nav.Link>

                <Nav.Link as={NavLink} to="/orders">
                  Orders
                </Nav.Link>
              </>
            )}

            {user.id !== null ? (
              user.isAdmin ? (
                <Nav.Link as={Link} to="/logout">
                  Logout
                </Nav.Link>
              ) : (
                <>
                  <Nav.Link as={NavLink} to="/profile">
                    Profile
                  </Nav.Link>

                  <Nav.Link as={NavLink} to="/logout">
                    Logout
                  </Nav.Link>
                </>
              )
            ) : (
              <>
                <Nav.Link as={NavLink} to="/login">
                  Login
                </Nav.Link>

                <Nav.Link
                  as={NavLink}
                  to="/register"
                  className="navbar-register"
                >
                  Register
                </Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
